/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var ActionTag;
(function (ActionTag) {
    ActionTag["ALL"] = "ALL";
    ActionTag["SOCIAL_MEDIA"] = "SOCIAL_MEDIA";
    ActionTag["JOB_BOARDS"] = "JOB_BOARDS";
    ActionTag["MESSAGING"] = "MESSAGING";
    ActionTag["EMAIL"] = "EMAIL";
    ActionTag["SCRIPTS"] = "SCRIPTS";
    ActionTag["GENERAL"] = "GENERAL";
    ActionTag["OPEN_POSITION"] = "OPEN_POSITION";
})(ActionTag || (ActionTag = {}));
